import React from 'react';
import { Card, Table, Empty, Skeleton, Typography, Space } from 'antd';

const headerCellStyle = { background: '#e6f4ff', color: '#1677ff', fontWeight: 600 };

const columnsBrand = [
  { title: 'Rank', dataIndex: 'rank', width: 64, onHeaderCell: () => ({ style: headerCellStyle }) },
  { title: 'Brand Name', dataIndex: 'brandName', ellipsis: true, onHeaderCell: () => ({ style: headerCellStyle }) },
  { title: 'Count', dataIndex: 'mentionCount', align: 'right', width: 92, onHeaderCell: () => ({ style: headerCellStyle }) },
];

const columnsUser = [
  { title: 'Rank', dataIndex: 'rank', width: 64, onHeaderCell: () => ({ style: headerCellStyle }) },
  { title: 'User Name', dataIndex: 'userName', ellipsis: true, onHeaderCell: () => ({ style: headerCellStyle }) },
  { title: 'Count', dataIndex: 'conversationCount', align: 'right', width: 92, onHeaderCell: () => ({ style: headerCellStyle }) },
];

export default function RankingPanel({ loadingBrand, loadingUser, brandData, userData }) {
  const [tab, setTab] = React.useState('brand');

  const Header = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Space size={12}>
        <Typography.Text
          onClick={() => setTab('brand')}
          style={{ cursor: 'pointer', color: tab === 'brand' ? '#1677ff' : '#1f1f1f', fontWeight: 600 }}
        >
          Brand Ranking
        </Typography.Text>
        <span style={{ color: '#d9d9d9' }}>|</span>
        <Typography.Text
          onClick={() => setTab('user')}
          style={{ cursor: 'pointer', color: tab === 'user' ? '#1677ff' : '#1f1f1f', fontWeight: 600 }}
        >
          User Activity Ranking
        </Typography.Text>
      </Space>
    </div>
  );

  const loading = tab === 'brand' ? loadingBrand : loadingUser;
  const data = tab === 'brand' ? brandData : userData;
  const columns = tab === 'brand' ? columnsBrand : columnsUser;
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <Card 
      title={Header} 
      styles={{ 
        body: { 
          padding: 12, 
          height: 'calc(100% - 57px)', 
          display: 'flex', 
          flexDirection: 'column' 
        } 
      }} 
      style={{ height: '100%' }}
    >
      {loading ? (
        <Skeleton active />
      ) : (
        <div style={{ flex: 1, overflow: 'hidden' }}>
          <style>{`
            .ranking-table .ant-table-tbody > tr > td {
              padding: 12px 16px;
              height: 48px;
            }
            .ranking-table .ant-table-tbody > tr {
              height: 48px;
            }
          `}</style>
          {hasData ? (
            <Table
              className="ranking-table"
              size="small"
              rowKey={(r) => `${r.rank}-${tab === 'brand' ? r.brandName : r.userId}`}
              columns={columns}
              dataSource={data}
              pagination={false}
              locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
            />
          ) : (
            <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )}
        </div>
      )}
    </Card>
  );
}


